import { BOARD_STATUS_META, type BoardStatus } from '@/lib/boardStatus';

// Per-status background/border tint. Colour + label come from BOARD_STATUS_META
// so the wording ("ออนไลน์ / หน่วง / ออฟไลน์ / ไม่มีข้อมูล") never drifts.
const TINT: Record<BoardStatus, { bg: string; br: string }> = {
  online: { bg: 'rgba(34,197,94,0.1)', br: 'rgba(34,197,94,0.3)' },
  stale: { bg: 'rgba(250,204,21,0.1)', br: 'rgba(250,204,21,0.3)' },
  offline: { bg: 'rgba(239,68,68,0.1)', br: 'rgba(239,68,68,0.3)' },
  never: { bg: 'rgba(148,163,184,0.1)', br: 'rgba(148,163,184,0.3)' },
};

/**
 * THE single board-status badge. Every page must render board connectivity
 * through this so the same state always looks and reads identically.
 */
export function BoardStatusBadge({ status }: { status: BoardStatus }) {
  const { color, label } = BOARD_STATUS_META[status];
  const tint = TINT[status];
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        padding: '3px 10px',
        borderRadius: 999,
        background: tint.bg,
        border: `1px solid ${tint.br}`,
        color,
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: '.02em',
        whiteSpace: 'nowrap',
      }}
    >
      <span
        style={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          background: color,
          display: 'inline-block',
        }}
      />
      {label}
    </span>
  );
}
